import { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { WarningOutlined, FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";

const { Text } = Typography;

const PdfPreviewModal = ({ pdfFileName }) => {  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  // Handle online/offline
  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleClose = () => setIsModalVisible(false);

  // ✅ View PDF in new tab
  const handleViewPdf = () => {
    if (!isOffline && pdfFileName) {
      window.open(`/${pdfFileName}`, "_blank");
    }
  };

  // ✅ Download PDF directly
  const handleDownloadPdf = () => {
    if (!isOffline && pdfFileName) {
      const link = document.createElement("a");
      link.href = `/${pdfFileName}`;
      link.download = pdfFileName; // Force download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      {/* 🔘 Common Button */}
      <Button type="primary" onClick={handleOpenModal}>
        View Guidelines
      </Button>

      {/* 📑 Modal */}
      <Modal
        title="Refer Guidelines"
        open={isModalVisible}
        onOk={handleClose}
        onCancel={handleClose}
        footer={[
          <Button key="close" onClick={handleClose}>
            Close
          </Button>,
          !isOffline && (
            <>
              <Button
                key="view"
                type="default"
                icon={<FilePdfOutlined />}
                onClick={handleViewPdf}
              >
                View PDF
              </Button>
              <Button
                key="download"
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleDownloadPdf}
              >
                Download PDF
              </Button>
            </>
          ),
        ]}
      >
        {isOffline ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <WarningOutlined style={{ fontSize: "24px", color: "orange" }} />
            <br />
            <Text type="danger">
              Unable to load. Please connect to the internet to view/download the file.
            </Text>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <FilePdfOutlined style={{ fontSize: "24px", color: "red" }} />
            <br />
            <Text>
              Click "View PDF" to open or "Download PDF" to save the file.
            </Text>
          </div>
        )}
      </Modal>
    </>
  );
};

export default PdfPreviewModal;
